import React from 'react'
import { usePage } from 'hooks'
import Header from 'components/app/Header'
import PageBody from 'components/app/PageBody'
import CompanyBreadcrumb from 'components/company/CompanyBreadcrumb'
import ReportHeader from 'components/report/view/ReportHeader'
import ReportContainer from 'components/report/view/ReportContainer'

export default function ReportPage() {
  const { header } = usePage()

  return (
    <PageBody
      renderHeader={() => (
        <>
          <Header>
            <CompanyBreadcrumb crumbs={header?.crumbs} />
          </Header>
          <ReportHeader />
        </>
      )}
      renderContent={() => <ReportContainer />}
    />
  )
}
